import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import type { Intent } from "@/v2-ui/types"
import type { IconNames } from "@/v2-ui/icon/icon.types"
import { isCustomIcon } from "@/v2-ui/icon/custom/icon.custom.utils"
import IconCustom from "@/v2-ui/icon/custom/IconCustom"

export type IconProps = ComponentProps<"span"> & {
  intent?: Intent
  size?: number
  src?: IconNames
  loading?: boolean
  alt?: string
  iconBackdrop?: boolean
  fill?: string
  inheritSize?: boolean
}

function Icon(props: IconProps) {
  const {
    intent,
    className,
    style,
    size = 16,
    src,
    loading,
    iconBackdrop,
    fill,
    role = "img",
    inheritSize,
    ...spanProps
  } = props

  const finalStyle = inheritSize
    ? style
    : {
        fontSize: size,
        width: size,
        height: size,
        flexShrink: 0,
        ...style,
      }

  if (src && isCustomIcon(src) && !loading) {
    return (
      <IconCustom
        src={src}
        className={className}
        fill={fill}
        style={{
          ...(inheritSize
            ? {}
            : {
                width: size,
                height: size,
                flexShrink: 0,
              }),
          ...style,
        }}
      />
    )
  }

  return (
    <span
      className={cn("icn fi", className, intent, {
        "is-loading": loading,
        [`fi-rr-${src}`]: !loading,
        "flex justify-center items-center bg-background/70": iconBackdrop,
        "flex justify-center items-center": !inheritSize && !iconBackdrop,
      })}
      role={loading ? "progressbar" : role}
      style={finalStyle}
      {...spanProps}
    />
  )
}

export default Icon
